import {useAuth} from "base/user/provider";
import {useNavigate} from "react-router-dom";
import {useState} from "react";

import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Logout from "@mui/icons-material/Logout";
import ListItemText from "@mui/material/ListItemText";

import {useChangePassword} from "base/user/hooks";

const AccountMenu = ({secondaryText = ""}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const {menuItem: menuItemChangePassword, dialog: dialogChangePassword} =
        useChangePassword();
    const {user, logout} = useAuth();
    let navigate = useNavigate();

    const open = Boolean(anchorEl);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Box
                sx={{
                    margin: "1 1.5",
                }}
            >
                <Tooltip title="Perfil do utilizador">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ml: 1, backgroundColor: "primary.light"}}
                        aria-controls={open ? "profile-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                    >
                        <Avatar
                            sx={{
                                width: 32,
                                height: 32,
                                backgroundColor: "#ffff",
                                color: "primary.main",
                            }}
                        />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="profile-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{horizontal: "right", vertical: "top"}}
                anchorOrigin={{horizontal: "right", vertical: "bottom"}}
            >
                <ListItem>
                    <Avatar />
                    <ListItemText primary={user.name} secondary={secondaryText} />
                </ListItem>
                <Divider />
                {menuItemChangePassword}

                <MenuItem
                    onClick={() => {
                        logout(() => navigate("/"));
                    }}
                >
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Fechar sessão
                </MenuItem>
            </Menu>
            {dialogChangePassword}
        </>
    );
};

export default AccountMenu;
